import { Map } from "immutable"

import { getList } from "./utils/entity-network-requests"

const entityName = "project"

export const getProjectList = (token, parameters) => {
    if (typeof parameters === "string" || parameters instanceof String) {
        // Actually a search term that comes from autocomplete
        parameters = new Map({ name: parameters })
    }
    return getList(entityName, parameters, token)
}
